import { makeStyles } from 'tss-react/mui';
import { THUMB_GAP } from '../../../../consts/gallery.consts';

export const useSquareGalleryStackStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: THUMB_GAP,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  media: {
    position: 'relative',
    flex: '0 0 auto',
    width: '100%',
    aspectRatio: '1',
    cursor: 'zoom-in',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
}));
